import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页", exact: true },
  { to: "/category/movie", label: "电影" },
  { to: "/category/tv", label: "电视剧" },
  { to: "/news", label: "资讯" },
  { to: "/about", label: "关于" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-background-200"
          : "bg-background-50 border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-18 gap-4">
          {/* Brand */}
          <Link to="/" className="flex items-center gap-2.5 cursor-pointer shrink-0">
            <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-film-line text-lg"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading font-semibold text-foreground-950 text-base tracking-tight">
                聚会的目的<span className="text-primary-500">在线</span>
              </span>
              <span className="text-[10px] text-foreground-500 tracking-[0.2em] mt-0.5">
                SCREEN PORTAL
              </span>
            </span>
          </Link>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.exact}
                className={({ isActive }) =>
                  `px-3.5 py-2 text-sm rounded-md transition-colors cursor-pointer whitespace-nowrap ${
                    isActive
                      ? "text-primary-600 font-medium bg-primary-50"
                      : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          {/* Desktop search */}
          <form onSubmit={submitSearch} className="hidden md:flex items-center gap-2 flex-1 max-w-xs">
            <div className="relative w-full">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影视作品…"
                className="w-full h-10 pl-9 pr-3 text-sm rounded-md bg-background-100 border border-background-200 focus:border-primary-400 focus:bg-background-50 outline-none transition-colors placeholder:text-foreground-400"
              />
            </div>
          </form>

          {/* Mobile controls */}
          <div className="flex items-center gap-2 md:hidden">
            <Link
              to="/search"
              aria-label="搜索"
              className="w-10 h-10 rounded-md flex items-center justify-center text-foreground-700 hover:bg-background-100 cursor-pointer"
            >
              <i className="ri-search-line text-lg"></i>
            </Link>
            <button
              type="button"
              aria-label="菜单"
              onClick={() => setMenuOpen((v) => !v)}
              className="w-10 h-10 rounded-md flex items-center justify-center text-foreground-900 hover:bg-background-100 cursor-pointer"
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile panel */}
      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 animate-fade-in">
          <div className="px-4 py-4">
            <form onSubmit={submitSearch} className="relative mb-3">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影视作品…"
                className="w-full h-11 pl-9 pr-3 text-sm rounded-md bg-background-100 border border-background-200 focus:border-primary-400 outline-none"
              />
            </form>
            <nav className="flex flex-col">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.exact}
                  className={({ isActive }) =>
                    `px-3 py-3 rounded-md text-sm transition-colors cursor-pointer ${
                      isActive
                        ? "text-primary-600 font-medium bg-primary-50"
                        : "text-foreground-700 hover:bg-background-100"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}